import { Component } from '@angular/core';

@Component({
  selector: 'app-brand-extends',
  templateUrl: './brand-extends.component.html',
  styleUrls: ['./brand-extends.component.css']
})
export class BrandExtendsComponent {

}
